import { render, staticRenderFns } from "./chi.vue?vue&type=template&id=32198ecc&scoped=true"
import script from "./chi.vue?vue&type=script&lang=js"
export * from "./chi.vue?vue&type=script&lang=js"
import style0 from "./chi.vue?vue&type=style&index=0&id=32198ecc&prod&lang=css"
import style1 from "./chi.vue?vue&type=style&index=1&id=32198ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32198ecc",
  null
  
)

export default component.exports